module.exports = __webpack_public_path__ + "static/media/arrow.b03177d7.svg";